import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import BanHangTraGopApi from "service/banHangTraGopApi";
import { pushNotification } from "utils/notifications";
import {
  getListCauHinhGoiTraGop,
  updateDataSearch,
} from "../../../../../actions/CauHinhGoiTraGop";
export const ModalXoa = (props) => {
  const dataSearch = useSelector((state) => state.dataSearchCauHinhGoiTraGop);
  const [isActiveSubmit, setIsActiveSubmit] = useState(false);
  const dispatch = useDispatch();
  const deleteSanPham = () => {
    setIsActiveSubmit(true);
    BanHangTraGopApi.xoaSanPham(props.Id).then((response) => {
      if (response.status == 200) {
        setIsActiveSubmit(false);
        props.onHide();
        pushNotification(
          "Xóa sản phẩm thành công",
          "success",
          "TOP_RIGHT",
          2000
        );
        dispatch(getListCauHinhGoiTraGop(dataSearch));
      } else {
        setIsActiveSubmit(false);
        pushNotification(response.data, "error", "TOP_RIGHT", 2000);
        props.onHide();
      }
    });
  };

  return (
    <Modal
      {...props}
      size="modal-dialog modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-delete"></i>
          </span>
          <span>Xác nhận xóa</span>
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="form-body">
              <div className="form-group row">
                <label
                  className="col-md-12 label-control text-left"
                  for="projectinput2"
                >
                  Bạn có chắc chắn muốn xóa không?
                </label>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-new-main btn-checknew"
          onClick={deleteSanPham}
          disabled={isActiveSubmit}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-check"></i>
          </span>
          Xác nhận
        </button>

        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
